import script from "./SmMetersCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmMetersCard.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "@/components/common/SmMetersCard/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fvitaliyprudnikov%2FWorkspace%2FWork%2Fveresk%2Fsrc%2Fcomponents%2Fcommon%2FSmMetersCard%2FSmMetersCard.vue&external"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__